import _ from '../../libs/lodash';

const __ = window.__;

const timeTracking = new webix.DataCollection();

timeTracking.getLogsByParams = function (ganttId, taskId, logId) {
  const ganttLogs = _.cloneDeep(this.getItem(ganttId));

  return timeTracking._getLogsByParams(ganttLogs, taskId, logId);
};

timeTracking.getLogsByParamsNotCopy = function (ganttId, taskId, logId) {
  const ganttLogs = this.getItem(ganttId);

  return timeTracking._getLogsByParams(ganttLogs, taskId, logId);
};

timeTracking._getLogsByParams = function (ganttLogs, taskId, logId) {
  if (!ganttLogs) {
    return false;
  }

  let result = ganttLogs;

  if (taskId) {
    result = ganttLogs.tasks[taskId];
  }

  if (logId) {
    const taskData = ganttLogs.tasks[taskId];

    if (!taskData) {
      return false;
    }

    result = _.find(taskData.logs, log => log.id === +logId);
  }

  return result;
};

export default timeTracking;
